function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "digital-product_svg__defs184"
}, /*#__PURE__*/React.createElement("style", {
  id: "style182"
}, ".digital-product_svg__cls-1{fill:#5e4dad}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "digital-product_svg__cls-1",
  d: "M76.78.01c-8.04 0-14.81 5.54-16.69 13.01H6.87c-1.8 0-3.5.69-4.79 1.94l-.01.01A6.812 6.812 0 000 19.89v44.47c0 1.89.79 3.72 2.17 5.02a6.88 6.88 0 004.69 1.85h64.88c1.74 0 3.41-.65 4.68-1.84l.03-.03a6.885 6.885 0 002.17-5.01V34.32c8.63-.92 15.37-8.24 15.37-17.11C93.99 7.72 86.27 0 76.78 0zM6.87 16.69h52.72v.53c0 3.29.93 6.36 2.53 8.98l-21.6 20.42h-2.4L6.48 16.71c.13-.02.27-.02.4-.02zm-3.2 3.2c0-.24.03-.48.08-.71l25.72 24.31L3.81 65.31c-.09-.3-.14-.62-.14-.95zm68.08 47.68H6.87h-.04l25.32-21.53 3.97 3.75c.34.32.79.5 1.26.5h3.86c.47 0 .92-.18 1.26-.5l3.97-3.75 25.32 21.53h-.05zm3.2-3.2c0 .33-.05.65-.14.95L49.15 43.5l15.21-14.38c2.74 2.85 6.44 4.77 10.59 5.21v30.03zm1.84-33.61c-7.46 0-13.54-6.07-13.54-13.54 0-7.47 6.07-13.54 13.54-13.54 7.47 0 13.54 6.07 13.54 13.54 0 7.47-6.07 13.54-13.54 13.54z",
  id: "digital-product_svg__path186"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "digital-product_svg__cls-1",
  d: "M77.4 11.34h-1.96c-1.01 0-1.84.82-1.84 1.84s.82 1.84 1.84 1.84h.13v7.34c0 1.01.82 1.84 1.84 1.84s1.84-.82 1.84-1.84v-9.18c0-1.01-.82-1.84-1.84-1.84z",
  id: "digital-product_svg__path188"
});

function SvgDigitalProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "digital-product_svg__Warstwa_1",
    viewBox: "0 0 93.99 71.23",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgDigitalProduct;